import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import PaginationModified from "../../../data/PaginationModified";
import GymWiseTaskStatusList from "./GymWiseTaskStatusList";

const GymwiseTaskLists = ({
  userInfoData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  prevAllFilters,
}) => {
  const {
    hygineGymwiseDataLoading,
    hygineGymwiseDataError,
    hygineGymwiseData,
  } = useSelector((state) => state.hygiene);

  const [openAccordion, setOpenAccordion] = useState(null);
  const [activeGym, setActiveGym] = useState(null);
  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function onCloseModal() {
    setModValues(iniModvalues);
  }

  const toggleAccordion = (index, row) => {
    setOpenAccordion(openAccordion === index ? null : index);
    setActiveGym(openAccordion === index ? null : row);
  };

  function getPagination() {
    try {
      const pagination =
        allDatas.pagination?.length > 0 ? allDatas.pagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (
      !hygineGymwiseDataLoading &&
      !hygineGymwiseDataError &&
      hygineGymwiseData?.status &&
      hygineGymwiseData?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: hygineGymwiseData.data,
        pagination:
          hygineGymwiseData?.pagination?.length > 0
            ? hygineGymwiseData.pagination
            : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [hygineGymwiseDataLoading, hygineGymwiseDataError, hygineGymwiseData]);

  const tbColumns = [
    {
      dataField: "task_id",
      text: "task name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.task_name || "NA"}</span>;
      },
    },
    {
      dataField: "total_tasks",
      text: "total tasks",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data badge bg-primary text-white"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "total_tasks",
                rowData: row,
              }))
            }
          >
            {row?.total_tasks || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_completed",
      text: "completed tasks",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data badge bg-success text-white"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "total_completed",
                rowData: row,
              }))
            }
          >
            {row?.total_completed || 0}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <GymWiseTaskStatusList
            userInfoData={userInfoData}
            modName={modValues.cardName}
            rowData={modValues.rowData}
            prevAllFilters={prevAllFilters}
            activeGym={activeGym}
            onCloseModal={onCloseModal}
          />
        </div>
      </Modal>

      {hygineGymwiseDataLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="hygine-accordian accordion-container">
          {allDatas.allData?.map((row, index) => (
            <div key={index} className="accordion-item">
              <div
                className={`accordion-header ${
                  openAccordion === index ? "active" : ""
                }`}
                onClick={() => toggleAccordion(index, row)}
              >
                <span className="accordion-title">{row?.gym_name || "NA"}</span>
                <span className="accordion-tasks">
                  Total Tasks: {row?.task_details?.length || 0}
                </span>
                <span className="accordion-icon">
                  {openAccordion === index ? "▲" : "▼"}
                </span>
              </div>

              {openAccordion === index && (
                <div className="accordion-content">
                  <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile">
                    <PaymentLinkTable
                      tableData={row?.task_details || []}
                      tableColumns={tbColumns}
                    />
                  </div>

                  <div className="lead-logs-card-container only-mobile">
                    <div
                      className="all-leads-log mt30"
                      style={{ marginBottom: "0" }}
                    >
                      {row?.task_details?.length > 0 &&
                        row?.task_details.map((row, index) => {
                          return (
                            <div className="log-card" key={index}>
                              <div className="all-info">
                                <div className="all-followuo-info-container">
                                  <div
                                    className="lead-multi-value-cols px20px pb20px"
                                    style={{ paddingTop: "20px" }}
                                  >
                                    <div className="label-value">
                                      <span className="label">task name</span>
                                      <span className="value">
                                        {row?.task_name || "NA"}
                                      </span>
                                    </div>

                                    <div className="label-value">
                                      <span className="label">total tasks</span>
                                      <span
                                        className="value badge bg-primary text-white"
                                        onClick={() =>
                                          setModValues((prevs) => ({
                                            ...prevs,
                                            isModOpen: true,
                                            cardName: "total_tasks",
                                            rowData: row,
                                          }))
                                        }
                                      >
                                        {row?.total_tasks || 0}
                                      </span>
                                    </div>

                                    <div className="label-value">
                                      <span className="label">
                                        completed tasks
                                      </span>
                                      <span
                                        className="value badge bg-success text-white"
                                        onClick={() =>
                                          setModValues((prevs) => ({
                                            ...prevs,
                                            isModOpen: true,
                                            cardName: "total_completed",
                                            rowData: row,
                                          }))
                                        }
                                      >
                                        {row?.total_completed || 0}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}

          <div className="lead-logs-card-pagination flexEnd">
            <PaginationModified
              isPage={isPage}
              onChangePage={setIsPage}
              pagination={getPagination()}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default GymwiseTaskLists;
